/* @flow */

import { escapeRegExp } from 'lodash'

const findWithRegex = (regex: any, contentBlock: any, callback: any) => {
  const contentBlockText = contentBlock.getText()

  // exclude entities, when matching
  contentBlock.findEntityRanges(
    (character: any) => !character.getEntity(),
    (nonEntityStart: any, nonEntityEnd: any) => {
      const text = contentBlockText.slice(nonEntityStart, nonEntityEnd)
      let matchArr
      let start
      let prevLastIndex = regex.lastIndex

      // Go through all matches in the text and return the indices to the callback
      // Break the loop if lastIndex is not changed
      while ((matchArr = regex.exec(text)) !== null) {
        // eslint-disable-line
        if (regex.lastIndex === prevLastIndex) {
          break
        }
        prevLastIndex = regex.lastIndex
        start = nonEntityStart + matchArr.index
        callback(start, start + matchArr[0].length)
      }
    }
  )
}

export const mentionSuggestionsStrategy = (
  trigger: string,
  supportWhiteSpace: boolean,
  regExp: string
) => {
  //eslint-disable-line
  const MENTION_REGEX = supportWhiteSpace
    ? new RegExp(`${escapeRegExp(trigger)}(${regExp}|\\s){0,}`, 'g')
    : new RegExp(`(\\s|^)${escapeRegExp(trigger)}${regExp}`, 'g')

  return (contentBlock: Object, callback: Function) => {
    findWithRegex(MENTION_REGEX, contentBlock, callback)
  }
}
